//
//
//
//
//
//
//
//
//

export default {
    name: "other3",
    created() {
        document.title = this.$t('other.other3')[0]
    }
}



// WEBPACK FOOTER //
// ./src/page/other/other3.vue